import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports

const calculateDesignerEarnings = (clientPrice, designerFeePercent) => {
    const introductionFee = Math.min(clientPrice, 500) * 0.2;
    const designerFee = clientPrice * designerFeePercent;

    const lowEarnings = Math.round(clientPrice - introductionFee - designerFee);
    const highEarnings = Math.round(clientPrice - designerFee);
    return [lowEarnings, highEarnings];
};

function PriceCalculator() {
    this.defaultAttrs({
        priceInputSelector: '[data-price-calculator-input]',
        priceOutputLowSelector: '[data-price-calculator-output-low]',
        priceOutputHighSelector: '[data-price-calculator-output-high]',
        percentage: '[data-price-calculator-percentage]',
    });

    this.after('initialize', function() {
        this.on('change', {
            priceInputSelector: this.calculatePrice,
        });
        this.on('keyup', {
            priceInputSelector: this.calculatePrice,
        });
    });

    this.calculatePrice = function() {
        const clientPrice = this.select('priceInputSelector').val();
        const designerFeePercent = this.$node.attr('data-price-calculator-percentage');
        const earnings = calculateDesignerEarnings(clientPrice, designerFeePercent);
        const priceLow = `${earnings[0]}.00`;
        const priceHigh = `${earnings[1]}.00`;
        this.select('priceOutputLowSelector').html(encodeURIComponent(priceLow));
        this.select('priceOutputHighSelector').html(encodeURIComponent(priceHigh));
    };
}

export default defineComponent(PriceCalculator);



// WEBPACK FOOTER //
// ./src/js/component_ui/price-calculator.js